/**
 * Address search against OUR backend, which asks Lantmäteriet (GF-77).
 *
 * ⚠️ CONTRAST THIS WITH getPlaces.js IN THE SAME FOLDER, which calls Mapbox
 * DIRECTLY from the browser with a public token. That is the path this one
 * replaces in the "Redigera adress" box, and the difference is not a style
 * preference:
 *
 *   - Lantmäteriet speaks OAuth2, and LM_CLIENT_SECRET can never be in a
 *     bundle. Going through our backend is the only way to ask it at all.
 *   - Because it goes through `request`, it carries the JWT and a dead session
 *     logs the operator out properly (GF-50) instead of silently returning
 *     nothing.
 *
 * getPlaces.js STAYS for now — Zone.jsx and SubZone.jsx still use it, and
 * swapping the source there would be an unmeasured behaviour change in fields
 * that hold place names rather than street addresses. GF-24/25/27 therefore
 * remain open for those call sites; see docs/FINDINGS.md.
 *
 * NOT `unattended`: a person is sitting and waiting for this answer, so a 401
 * should log them out rather than fail quietly. That is the default; it is
 * named here only because the opposite is easy to add by reflex.
 */
import request from "../utils/request";

/** LM's own contract: the search string is 3-300 characters. */
export const SEARCH_MIN_LENGTH = 3;
export const SEARCH_MAX_LENGTH = 300;

/**
 * Resolves to `{ response }` or `{ error }` — never throws, like every other
 * caller of `request`.
 */
export default function searchAddress(query) {
  return request(`/geocode/search?q=${encodeURIComponent(query)}`, {
    method: "GET",
  });
}
